import React from 'react';
import { connect } from 'react-redux';

import { isBannerPlatform } from 'depop/utils/deeplinks';

import BuyButton from './BuyButton';

class DeeplinkBuyButton extends React.Component {
  props: {
    overlays: Object,
    userAgent: Object,
    product: Object,
    from: ?String,
    listIndex: ?String,
  };

  constructor(props) {
    super(props);
    this.state = {mounted: false};
  }

  componentDidMount() {
    this.setState({mounted: true});
  }

  render() {
    const { userAgent, overlays, product, from, listIndex } = this.props;
    const { mounted } = this.state;
    const buttonParams = isBannerPlatform(userAgent.platform) ? overlays.deeplink : {};

    if (!mounted) {
      return null;
    }

    return <BuyButton
      product={product}
      from={from}
      listIndex={listIndex}
      {...buttonParams}
    />;
  }
}

const mapStateToProps = ({ userAgent, overlays }) => ({
  userAgent,
  overlays,
});

export default connect(mapStateToProps)(DeeplinkBuyButton);



// WEBPACK FOOTER //
// ../src/client/apps/shops/components/DeeplinkBuyButton.js